module.exports = __webpack_public_path__ + "img/class7.c6e4d90e.png";